<template>
  <div
    ref="smartsticky"
    class="smart-sticky-header"
    :class="{ sticky: isSticky }"
    :style="{ top: itemHeight + 'px' }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SmartStickyHeader',
  props: {
    itemHeight: {
      type: Number,
      default: -100,
    },
  },
  data() {
    return {
      isSticky: false,
    }
  },
  computed: {},
  methods: {
    handleScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop
      const rect = this.$el.getBoundingClientRect()

      if (currentScrollPosition < this.lastScrollPosition && rect.top <= 0) {
        this.isSticky = true
      } else if (
        currentScrollPosition > this.lastScrollPosition ||
        rect.top > 0
      ) {
        this.isSticky = false
      }
      this.lastScrollPosition = currentScrollPosition
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeCreate() {},
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';

.smart-sticky-header {
  position: relative;
  top: -100px;
  padding: 12px 0 20px 0;
  transition: top 0.3s ease-in-out;
  z-index: 0;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 80%,
    rgba(255, 255, 255, 0) 88%,
    rgba(255, 255, 255, 0) 100%
  );
  position: sticky;
  &.sticky {
    top: 0 !important;
    z-index: 4;
  }
}
@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1200px) {
  .smart-sticky-header {
    display: none;
  }
}
</style>
